import { Title, useTranslate } from 'react-admin';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

function NotFound() {
  const t = useTranslate();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 text-center">
      <Title title="Not Found" />
      <div className="rounded-xl border border-border bg-muted/20 px-8 py-6">
        <span
          className="text-7xl font-black"
          style={{
            background:
              'linear-gradient(140deg, #F5F5F5 0.49%, #737373 100.5%)',
            backgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          404
        </span>
      </div>
      <div className="max-w-[500px]">
        <h4 className="text-2xl font-bold mb-1">{t('error.404.header')}</h4>
        <p className="text-lg text-muted-foreground mb-6">
          {t('error.404.message')}
        </p>
        <Button variant="outline" size="lg" asChild>
          <Link to="/">{t('error.full_screen.button')}</Link>
        </Button>
      </div>
    </div>
  );
}

export default NotFound;
